<div class="flex items-center">
  <button class="mr-6" (click)="prev()">
    <mat-icon svgIcon="prevBtn"></mat-icon>
  </button>
  <div class="grid items-center grid-cols-1 lg:grid-cols-5 gap-6">
    <div
      class="p-4 min-w-full h-56 text-center border rounded-md flex flex-col items-center justify-center"
      *ngFor="let item of visibleItems; let i = index"
    >
      <!-- <p>{{item.icon}}</p> -->
      <mat-icon [svgIcon]="item.icon" style="height: 40px; width: 40px"></mat-icon>
      <h1>{{ item.title }}</h1>
      <p id="phone">{{ item.phoneNumber }}</p>
    </div>
  </div>
  <button class="ml-6" (click)="next()">
    <mat-icon svgIcon="nextBtn"></mat-icon>
  </button>
</div>
